import { Incident } from '../types/incident';

export const initialIncidents: Incident[] = [
  {
    id: 'INC-2026-0001',
    caseTypeId: 'qarax',
    date: '2026-03-15',
    stateId: 'hirshabelle',
    regionId: 'hiiraan',
    districtId: 'beledweyne',
    location: 'Suuqa Magaalada (Town Market)',
    agencyId: 'somali-police',
    description: 'An explosive device detonated near the town market, causing casualties and property damage.',
    numCases: 1,
    numDeaths: 2,
    numInjuries: 6,
    severity: 'High',
    status: 'Approved',
    createdAt: '2026-03-15T09:12:00Z',
    reviewedAt: '2026-03-16T10:00:00Z'
  },
  {
    id: 'INC-2026-0002',
    caseTypeId: 'clan-conflict',
    date: '2026-04-05',
    stateId: 'galmudug',
    regionId: 'galgaduud',
    districtId: 'dhuusamareeb',
    location: 'Dhuusamareeb Town Center',
    agencyId: 'state-police',
    description: 'Armed clashes between rival clan militias erupted in the town center.',
    numCases: 1,
    numDeaths: 3,
    numInjuries: 8,
    severity: 'High',
    status: 'Approved',
    createdAt: '2026-04-05T14:40:00Z',
    reviewedAt: '2026-04-06T11:20:00Z'
  },
  {
    id: 'INC-2026-0003',
    caseTypeId: 'civil-unrest',
    date: '2026-05-12',
    stateId: 'banaadir',
    regionId: 'banaadir-region',
    districtId: 'hodan',
    location: 'Hodan District',
    agencyId: 'somali-police',
    description: 'Public demonstration escalated into disorder, requiring police intervention.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 4,
    severity: 'Medium',
    status: 'Submitted',
    createdAt: '2026-05-12T08:05:00Z'
  },
  {
    id: 'INC-2026-0004',
    caseTypeId: 'security-breach',
    date: '2026-05-20',
    stateId: 'south-west',
    regionId: 'bay',
    districtId: 'baidoa',
    location: 'Baidoa Town',
    agencyId: 'district-admin',
    description: 'Security breach reported near government installation in Baidoa.',
    numCases: 1,
    numDeaths: 1,
    numInjuries: 5,
    severity: 'High',
    status: 'Approved',
    createdAt: '2026-05-20T16:22:00Z',
    reviewedAt: '2026-05-21T09:10:00Z'
  },
  {
    id: 'INC-2026-0005',
    caseTypeId: 'armed-attack',
    date: '2026-06-08',
    stateId: 'jubaland',
    regionId: 'gedo',
    districtId: 'garbahaarey',
    location: 'Garbahaarey Market',
    agencyId: 'state-police',
    description: 'Armed assailants opened fire at a busy marketplace.',
    numCases: 1,
    numDeaths: 2,
    numInjuries: 3,
    severity: 'High',
    status: 'Approved',
    createdAt: '2026-06-08T07:50:00Z',
    reviewedAt: '2026-06-09T09:00:00Z'
  },
  {
    id: 'INC-2026-0006',
    caseTypeId: 'security-breach',
    date: '2026-06-22',
    stateId: 'puntland',
    regionId: 'bari',
    districtId: 'bosaso',
    location: 'Bosaso Port Area',
    agencyId: 'somali-police',
    description: 'Unauthorized entry attempt reported at the port security perimeter.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 1,
    severity: 'Medium',
    status: 'Submitted',
    createdAt: '2026-06-22T12:30:00Z'
  },
  {
    id: 'INC-2026-0007',
    caseTypeId: 'clan-conflict',
    date: '2026-07-04',
    stateId: 'hirshabelle',
    regionId: 'middle-shabelle',
    districtId: 'jowhar',
    location: 'Jowhar Outskirts',
    agencyId: 'district-admin',
    description: 'Escalated communal conflict resulted in multiple casualties in the outskirts of Jowhar.',
    numCases: 1,
    numDeaths: 4,
    numInjuries: 9,
    severity: 'Critical',
    status: 'Approved',
    createdAt: '2026-07-04T06:15:00Z',
    reviewedAt: '2026-07-04T18:00:00Z'
  },
  {
    id: 'INC-2026-0008',
    caseTypeId: 'civil-unrest',
    date: '2026-07-18',
    stateId: 'banaadir',
    regionId: 'banaadir-region',
    districtId: 'wadajir',
    location: 'Wadajir District',
    agencyId: 'other-gov',
    description: 'Reported unrest near a public gathering; details under review.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 1,
    severity: 'Low',
    status: 'Rejected',
    createdAt: '2026-07-18T11:00:00Z',
    reviewedAt: '2026-07-19T09:30:00Z',
    reviewNote: 'Insufficient supporting evidence provided by reporting agency.'
  },
  {
    id: 'INC-2026-0009',
    caseTypeId: 'qarax',
    date: '2026-08-02',
    stateId: 'south-west',
    regionId: 'lower-shabelle',
    districtId: 'marka',
    location: 'Marka Central Market',
    agencyId: 'somali-police',
    description: 'Explosive device found and detonated near the central market area.',
    numCases: 1,
    numDeaths: 2,
    numInjuries: 7,
    severity: 'High',
    status: 'Submitted',
    createdAt: '2026-08-02T10:45:00Z'
  },
  {
    id: 'INC-2026-0010',
    caseTypeId: 'kidnapping',
    date: '2026-08-09',
    stateId: 'galmudug',
    regionId: 'mudug',
    districtId: 'galkayo',
    location: 'Galkayo Highway',
    agencyId: 'state-police',
    description: 'A civilian was reportedly abducted along the main highway.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 0,
    severity: 'Medium',
    status: 'Approved',
    createdAt: '2026-08-09T15:00:00Z',
    reviewedAt: '2026-08-10T09:00:00Z'
  },
  {
    id: 'INC-2026-0011',
    caseTypeId: 'security-breach',
    date: '2026-08-15',
    stateId: 'banaadir',
    regionId: 'banaadir-region',
    districtId: 'karan',
    location: 'Karan District',
    agencyId: 'somali-police',
    description: 'Suspicious activity reported near a government compound.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 3,
    severity: 'Medium',
    status: 'Submitted',
    createdAt: '2026-08-15T09:20:00Z'
  },
  {
    id: 'INC-2026-0012',
    caseTypeId: 'armed-attack',
    date: '2026-08-20',
    stateId: 'puntland',
    regionId: 'nugaal',
    districtId: 'garowe',
    location: 'Garowe Outskirts',
    agencyId: 'state-police',
    description: 'Armed men attacked a checkpoint on the outskirts of Garowe.',
    numCases: 1,
    numDeaths: 0,
    numInjuries: 2,
    severity: 'Medium',
    status: 'Approved',
    createdAt: '2026-08-20T13:10:00Z',
    reviewedAt: '2026-08-21T09:00:00Z'
  }
];
